import Validators from '../validators'

export default (store) => {
  return {
    pricings: store.createEmbededEntityState({
      attrs: [
        'id',
        'valid_from',
        'valid_to',
        'utc_flag',
        'quality_mobile_price',
        'quality_sd_price',
        'quality_hd_price',
        'quality_uhd_price',
        'period_length',
        'period_time_unit',
        'coming_soon_flag',
        'regions',
        'currency_cd'
      ],
      titles: [
        store.__('ID'),
        store.__('Valid from'),
        store.__('Valid to'),
        store.__('UTC time'),
        store.__('Mobile price'),
        store.__('SD price'),
        store.__('HD price'),
        store.__('UHD price'),
        store.__('Period length'),
        store.__('Period time unit'),
        store.__('Coming soon'),
        store.__('Regions'),
        store.__('Currency')
      ],
      _sortField: 'currency_cd,period_time_unit,period_length,valid_from',
      _sortDir: 'ASC,ASC,ASC,ASC',
      timeRestriction: 'pricings',

      initVals: (row) => ({ control_timestamp: Math.round(new Date().getTime()) }),

      validators: {
        valid_from: [Validators.isMandatoryDate(store), Validators.isValidFromTo(store)],
        valid_to: [Validators.isMandatoryDate(store), Validators.isValidFromTo(store)],
        regions: [
          Validators.isMandatory(store),
          Validators.regionTest(store),
          Validators.regionOverlapping(store, null, false)],
        currency_cd: [Validators.isMandatory(store)],
        period_length: Validators.isMandatoryParams(store, ['type_sale', 'SVOD', true]),
        period_time_unit: Validators.isMandatoryParams(store, ['type_sale', 'SVOD', true]),

        _global: (vals, items) => {
          // disable prices if coming soon
          const isCommingSoon = (vals.has('coming_soon_flag') && vals.get('coming_soon_flag'))
          if (isCommingSoon) {
            vals.set('quality_mobile_price', '')
            vals.set('quality_sd_price', '')
            vals.set('quality_hd_price', '')
            vals.set('quality_uhd_price', '')
          }
          // type_sale is not set
          const record = store.cv && store.cv.record
          const avod = record && record.has('type_sale') && record.get('type_sale') === 'AVOD'
          if (record &&
            (!record.has('type_sale') || !record.get('type_sale'))) {
            return [store.__('Set "Sale type" before adding new pricing')]
          }
          // period length/time together
          if ((vals.get('period_length') &&
          !vals.get('period_time_unit')) ||
            (vals.get('period_time_unit') &&
            !vals.get('period_length'))) {
            return [store.__('Set "Period length" and "Period time unit" together')]
          }
          // at least one quality
          const mobi = vals.get('quality_mobile_price')
          const sd = vals.get('quality_sd_price')
          const hd = vals.get('quality_hd_price')
          const uhd = vals.get('quality_uhd_price')
          if (!isCommingSoon &&
            !(mobi || sd || hd || uhd)) {
            return avod
              ? [store.__('Please set at least one price. For use with AVOD set price to 0.')]
              : [store.__('Please set at least one price.')]
          }
          if (!isCommingSoon && avod && (mobi > 0 || sd > 0 || hd > 0 || uhd > 0)) {
            return [store.__('For use with AVOD the price cannot be higher than 0.')]
          }
        }
      }
    })
  }
}
